// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".group-page-menu-sharing[data-v-d87f21f2]{margin-top:10px;text-align:left;padding:0 15px;background-color:#0065b0;border-radius:5px}.group-page-menu-sharing__header[data-v-d87f21f2]{color:white;font-size:22px;font-weight:bold}\n", ""]);
// Exports
module.exports = exports;
